import { useContext } from 'react'
import { DownloadingContextProvider } from '../../provider/downloading-context.provider'

export const useDownloadingContext = () => {
  const context = useContext(DownloadingContextProvider)
  if (!context) {
    console.error('useDownloadingContext must be used within DownloadingProvider')
    throw new Error('useDownloadingContext must be used within DownloadingProvider')
  }
  return context
}
